module.exports = __webpack_public_path__ + "img/DSC_2226_referencia.57b0fd4e.jpg";